import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { withValidator } from '../../validation/withValidator.js';
import { FEEDBACK_METHOD } from './constants.js';
import { validatorObj } from './getObjectValidator.js';
export const FeedbackMethodField = JSX(({ field }) => (_jsx(SelectControl, { label: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043E\u0442\u0432\u0435\u0442\u0430", options: FEEDBACK_METHOD, ...withValidator(field('feedbackMethod'), validatorObj.feedbackMethod) })));
//# sourceMappingURL=FeedbackMethodField.js.map